import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { communityFeedApi } from 'src/Services/API';
import { editCommunityFeedItemCache } from 'src/Services/API/cache';
import { CommunityFeedItemDto, EditCommunityFeedItemDto } from 'src/Services/API/generated';

export type EditCommunityFeedItemVariable = EditCommunityFeedItemDto & { feedItemId: string };

export const useEditCommunityFeedItem = (
  options?: UseMutationOptions<CommunityFeedItemDto, unknown, EditCommunityFeedItemVariable>
) => {
  const queryClient = useQueryClient();

  return useMutation<CommunityFeedItemDto, unknown, EditCommunityFeedItemVariable>(
    'edit-community-feed-item',
    async (data: EditCommunityFeedItemVariable) => {
      const response = await communityFeedApi.communityFeedControllerEditFeedItem(
        data.feedItemId,
        data
      );

      return response.data;
    },
    {
      ...options,
      onSuccess(updatedFeedItem, _1, _2) {
        editCommunityFeedItemCache(queryClient, feedItem =>
          feedItem.id === updatedFeedItem.id ? updatedFeedItem : feedItem
        );

        options?.onSuccess?.(updatedFeedItem, _1, _2);
      },
    }
  );
};
